import Image from 'next/image'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NowGeneralContextProvider } from '../../../../now'
import {
  type ProductSearchConfig,
  ProductSearchContextProvider,
  ProductSearchRefinements,
  ProductSearchRefinementsButton,
  ProductSearchRefinementSortingSelect,
  ProductSearchRefinementStateProvider,
} from '../../../../product-search'
import { type StoryblokComponentProps } from '../../../model'
import { type StoryblokProductSearchType } from '../../../model/storyblokTypes.generated'

import { StoryblokBrandAlgoliaSearch } from './StoryblokBrandAlgoliaSearch'
import { StoryblokBrandProductSearchResults } from './StoryblokBrandProductSearchResults'

export const StoryblokBrandProductSearch: FC<
  StoryblokComponentProps<StoryblokProductSearchType> & {
    productSearchConfig: ProductSearchConfig
  }
> = ({ blok, productSearchConfig }) => {
  // this will be replaced with the brand code from story when available and other filters that can be added in product search (ex:'brandCode:csd2300')
  const brandCodeFilterFromBlok = null
  const stockStatusFiltersBlok =
    '(stockStatusReason:product.stockStatus.available OR stockStatusReason:product.stockStatus.nl)'

  const brandPageFilters = [brandCodeFilterFromBlok, stockStatusFiltersBlok]
    .filter(Boolean)
    .join(' AND ')

  /* eslint-disable react/jsx-max-depth -- it's a page with multiple providers */
  return (
    <ProductSearchContextProvider productSearchConfig={productSearchConfig}>
      <NowGeneralContextProvider>
        <StoryblokBrandAlgoliaSearch filters={brandPageFilters}>
          <div className="py-6" data-qa-id="brand-page-search">
            <div className="flex flex-col gap-3 desktop:hidden desktop:gap-6">
              <h1 className="mb-6 text-3xl font-medium">{blok.component}</h1>
              <ProductSearchRefinementsButton className="desktop:hidden" />
            </div>
            <div className="grid gap-4 pt-5 desktop:grid-cols-10 desktop:items-start desktop:gap-6 desktop:pt-0">
              <div className="hidden flex-col gap-6 desktop:col-span-3 desktop:flex">
                <Image
                  alt="brand description text"
                  height={128}
                  src="https://static.shop-apotheke.com/brand-logos/voltaren.jpg"
                  unoptimized
                  width={206}
                />
                <div className="flex flex-col gap-4 rounded-lg bg-light-primary-medium p-4">
                  <h5 className="text-l font-medium">
                    <FormattedMessage id="general.label.filterSearch" />
                  </h5>
                  <div className="flex flex-col gap-4">
                    <ProductSearchRefinementStateProvider>
                      <ProductSearchRefinementSortingSelect />
                      <ProductSearchRefinements />
                    </ProductSearchRefinementStateProvider>
                  </div>
                </div>
              </div>
              <div className="desktop:col-span-7">
                <StoryblokBrandProductSearchResults />
              </div>
            </div>
          </div>
        </StoryblokBrandAlgoliaSearch>
      </NowGeneralContextProvider>
    </ProductSearchContextProvider>
  )
  /* eslint-enable react/jsx-max-depth */
}
